// extracted by mini-css-extract-plugin
export var arrowDown = "subMenuDesktop-module--arrowDown--26322";
export var arrowUp = "subMenuDesktop-module--arrowUp--2f7b7";
export var menuSubItem = "subMenuDesktop-module--menuSubItem--18cad";
export var wrapper = "subMenuDesktop-module--wrapper--2e76a";